import { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import type { Swiper as SwiperType } from 'swiper';
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames'
import OutLink from '@/components/OutLink';
import { preFixImgUrl } from '@/utils'
import useModel from './useModel'
import { PlatformEnum } from '@/service/api/types'
import { useNavigate } from 'react-router-dom';

const HanedaShop = () => {
  const { t } = useTranslation();
  const { brands, services } = useModel();
  const navigate = useNavigate();
  const swiperRef = useRef<SwiperType | null>(null)
  const [activeSwiper, setActiveSwiper] = useState(0)


  return (
    <div className=''>
      <div className='h-[800px] bg-cover bg-center bg-no-repeat flex items-center justify-center' style={{ backgroundImage: `url(${preFixImgUrl('3cd380ae1b6e24190c9a39ef8749f027.png')})` }}>
        <div className='w-8xl mx-auto px-10'>
          <div className='bg-[#F4FFFF] rounded-[20px] py-10 px-[60px] flex items-center justify-between'>
            <div className='flex flex-col gap-6'>
              <div className='rounded-[12px] rounded-bl-[0] bg-[#0CBCD6] w-fit h-[35px] leading-[35px]'>
                <LangText lngKey='bedfe650' className='text-white text-[18px] px-3'>{t('bedfe650')}</LangText>
              </div>
              <LangText lngKey='54f65e85' className='text-[44px] font-bold text-black'>{t('54f65e85')}</LangText>
              <LangText lngKey='a418067e' className='text-[18px] text-[#666666] w-[430px] leading-[1.5]'>{t('a418067e')}</LangText>
              <div className='flex gap-4'>
                <OutLink platform={PlatformEnum.JAPANMALL}>
                  <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px]  w-fit text-[18px] bg-linear-to-r from-[#00B5D0] to-[#17D3EF] text-white cursor-pointer'>
                    <LangText lngKey='8f9bb764'>{t('8f9bb764')}</LangText>
                  </div>
                </OutLink>
                {/* <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] outline outline-[#131313] w-fit text-[18px] hover:bg-linear-to-r from-[#00B5D0] to-[#17D3EF] hover:text-white hover:outline-none cursor-pointer'>
                <LangText lngKey='0041aaa7'>{t('0041aaa7')}</LangText>
              </div> */}
              </div>
            </div>
            <img src={preFixImgUrl('bd425e2bcb5b99db9af260666d2324ff.png')} className='h-[415px] w-[555px]' />
          </div>
        </div>

      </div>
      {/* 分类-品牌 */}
      <div className='w-full bg-[#D8FFFE] pt-[170px] pb-[128px]'>
        <div className='w-8xl mx-auto px-10 flex flex-col items-center'>
          <LangText className='text-[36px] font-bold text-black' lngKey='e7a73978'>{t('e7a73978')}</LangText>
          <div className='flex justify-between gap-[10px] mt-[71px]'>
            <div className='bg-linear-to-t from-[#6FEDFF] to-[#B9F6FF] w-[232px] h-[284px] rounded-[20px] pt-9 flex flex-col justify-between items-center overflow-hidden'>
              <img src={preFixImgUrl('ca5d8e24bd1770be68e487f628fecee7.png')} className='h-[150px]' />
              <div className='w-full h-[56px] flex items-center justify-center text-center bg-[#0FCAE5]'>
                <LangText lngKey='4bae91f8' className='text-white text-[26px]'>{t('4bae91f8')}</LangText>
              </div>
            </div>
            <div className='bg-linear-to-t from-[#6FEDFF] to-[#B9F6FF] w-[232px] h-[284px] rounded-[20px] pt-9 flex flex-col justify-between items-center overflow-hidden'>
              <img src={preFixImgUrl('1a510cccc29928974b14ff521df62b8a.png')} className='h-[150px] ml-8' />
              <div className='w-full h-[56px] flex items-center justify-center text-center bg-[#0FCAE5]'>
                <LangText lngKey='c2f4d2d1' className='text-white text-[26px]'>{t('c2f4d2d1')}</LangText>
              </div>
            </div>
            <div className='bg-linear-to-t from-[#6FEDFF] to-[#B9F6FF] w-[232px] h-[284px] rounded-[20px] pt-9 flex flex-col justify-between items-center overflow-hidden'>
              <img src={preFixImgUrl('63c66d9251137b057b6cbbf852434628.png')} className='h-[150px]' />
              <div className='w-full h-[56px] flex items-center justify-center text-center bg-[#0FCAE5]'>
                <LangText lngKey='139582a5' className='text-white text-[26px]'>{t('139582a5')}</LangText>
              </div>
            </div>
            <div className='bg-linear-to-t from-[#6FEDFF] to-[#B9F6FF] w-[232px] h-[284px] rounded-[20px] pt-9 flex flex-col justify-between items-center overflow-hidden'>
              <img src={preFixImgUrl('fd0b85afb65e058dce348acb6e689ba6.png')} className='h-[150px]' />
              <div className='w-full h-[56px] flex items-center justify-center text-center bg-[#0FCAE5]'>
                <LangText lngKey='dc87b564' className='text-white text-[26px]'>{t('dc87b564')}</LangText>
              </div>
            </div>
            <div className='bg-linear-to-t from-[#6FEDFF] to-[#B9F6FF] w-[232px] h-[284px] rounded-[20px] pt-9 flex flex-col justify-between items-center overflow-hidden'>
              <img src={preFixImgUrl('fc98ddfccf530e40ed68250885a6cea0.png')} className='h-[128px] mt-[12px]' />
              <div className='w-full h-[56px] flex items-center justify-center text-center bg-[#0FCAE5]'>
                <LangText lngKey='4771dfd1' className='text-white text-[26px]'>{t('4771dfd1')}</LangText>
              </div>
            </div>
          </div>
          <div className='mt-[82px] flex gap-[34px] flex-wrap justify-center'>
            {
              brands.map(brand => <img key={brand.img} src={brand.img} className='w-[198px] h-[104px] transition-transform duration-300 hover:scale-110' object-fit='contain' />)
            }
          </div>
        </div>
      </div>
      {/* 服务优势 */}
      <div className='w-full bg-[#EEFFFE] pt-[139px] pb-[140px]'>
        <div className='w-8xl mx-auto px-10 flex flex-col items-center'>
          <LangText className='text-[36px] font-bold text-black' lngKey='de815dab'>{t('de815dab')}</LangText>
          <div className='w-full h-[482px] bg-contain bg-center bg-no-repeat mt-[44px] relative' style={{ backgroundImage: `url(${preFixImgUrl('4cfbf1b1567d7c9befbe8066dd1dfc89.png')})` }}>
            <div className='flex flex-col gap-7 pt-[192px] ml-[102px]'>
              {
                services.map((item, index) => (
                  <div
                    key={item.titleKey}
                    className='flex items-center cursor-pointer'
                    onClick={() => {
                      setActiveSwiper(index)
                      swiperRef.current?.slideToLoop(index)
                    }}>
                    <span className={classNames('w-3 h-3 rounded-[50%] mr-4', activeSwiper === index ? 'bg-[#1DF7FF]' : 'bg-white')}></span>
                    <LangText lngKey={item.titleKey} className='text-[18px] text-white'>{t(item.titleKey)}</LangText>
                  </div>
                ))
              }
            </div>
            <div className='w-[337px] absolute right-[148px] bottom-0'>
              <Swiper
                slidesPerView='auto'
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                loop
                modules={[Autoplay]}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper
                }}

                onRealIndexChange={(swiper: SwiperType) => {
                  const realIndex = swiper.realIndex
                  setActiveSwiper(realIndex)
                }}

              >
                {
                  services.map((item, index) => (
                    <SwiperSlide key={index}>
                      <img src={item.img} className='w-[337px] h-[418px]' />
                    </SwiperSlide>
                  ))
                }
              </Swiper>
            </div>
          </div>
        </div>
      </div>
      {/* 使用流程 */}
      <div className='bg-white'>
        <div className='w-8xl mx-auto px-10 pt-[139px] pb-[140px] flex flex-col items-center'>
          <LangText className='text-[36px] font-bold text-black' lngKey='e6cdc335'>{t('e6cdc335')}</LangText>
          <div className='flex gap-[120px] mt-[113px]'>
            <div className='flex flex-col w-[313px] items-center text-center'>
              <div className='bg-[#03BFDB] rounded-[34px] w-[118px] h-[118px] flex items-center justify-center relative'>
                <span className='text-[52px] text-white font-bold relative'>
                  01
                  <span className='absolute bottom-0 left-0 right-0 h-[30px] bg-linear-to-b form-white to-[#03BFDB]'></span>
                </span>
                <div className='flex w-[217px] items-center justify-between absolute left-[167px]'>
                  <span className='w-[8px] h-[8px] bg-[#03BFDB] rounded-[50%]'></span>
                  <span className="w-full border-b border-dashed border-[#03BFDB]"></span>
                  <span className='w-[8px] h-[8px] bg-[#03BFDB] rounded-[50%]'></span>
                </div>
              </div>
              <LangText className='text-[30px] font-bold text-black mt-9' lngKey='71dc3d01'>{t('71dc3d01')}</LangText>
              <LangText className='text-[18px]  text-[#666666] mt-5 leading-[30px]' lngKey='e811c1aa'>{t('e811c1aa')}</LangText>
            </div>

            <div className='flex flex-col w-[313px] items-center text-center'>
              <div className='bg-[#03BFDB] rounded-[34px] w-[118px] h-[118px] flex items-center justify-center relative'>
                <span className='text-[52px] text-white font-bold relative'>
                  02
                  <span className='absolute bottom-0 left-0 right-0 h-[30px] bg-linear-to-b form-white to-[#03BFDB]'></span>
                </span>
                <div className='flex w-[217px] items-center justify-between absolute left-[167px]'>
                  <span className='w-[8px] h-[8px] bg-[#03BFDB] rounded-[50%]'></span>
                  <span className="w-full border-b border-dashed border-[#03BFDB]"></span>
                  <span className='w-[8px] h-[8px] bg-[#03BFDB] rounded-[50%]'></span>
                </div>
              </div>
              <LangText className='text-[30px] font-bold text-black mt-9' lngKey='1a33df55'>{t('1a33df55')}</LangText>
              <LangText className='text-[18px]  text-[#666666] mt-5 leading-[30px]' lngKey='9dccdbad'>{t('9dccdbad')}</LangText>
            </div>

            <div className='flex flex-col w-[313px] items-center text-center'>
              <div className='bg-[#03BFDB] rounded-[34px] w-[118px] h-[118px] flex items-center justify-center relative'>
                <span className='text-[52px] text-white font-bold relative'>
                  03
                  <span className='absolute bottom-0 left-0 right-0 h-[30px] bg-linear-to-b form-white to-[#03BFDB]'></span>
                </span>
              </div>
              <LangText className='text-[30px] font-bold text-black mt-9' lngKey='26fe8655'>{t('26fe8655')}</LangText>
              <LangText className='text-[18px]  text-[#666666] mt-5 leading-[30px]' lngKey='a30923cf'>{t('a30923cf')}</LangText>
            </div>
          </div>
        </div>
      </div>
      {/* 准备好了吗 */}
      <div className='w-full h-[436px] bg-cover bg-center bg-no-repeat flex flex-col items-center' style={{ backgroundImage: `url(${preFixImgUrl('ed734bc5185d1a84872e8942a33bd314.png')})` }}>
        <LangText className='text-white text-[44px] mt-[113px]' lngKey='8e096226'>{t('8e096226')}</LangText>
        <LangText className='text-white text-[30px] mt-[30px] font-normal' lngKey='cb08e6ac'>{t('cb08e6ac')}</LangText>
        <div className='flex gap-[25px] mt-[60px]'>
          <OutLink platform={PlatformEnum.JAPANMALL}>
            <div className='h-[62px] min-w-[231px] text-white px-[44px] flex items-center justify-center rounded-[31px] w-fit text-[24px] bg-linear-to-r from-[#00B5D0] to-[#17D3EF] cursor-pointer'>
              <LangText lngKey='be730b5d'>{t('be730b5d')}</LangText>
            </div>
          </OutLink>
          <div onClick={() => navigate('/service-center')} className='h-[62px] min-w-[231px] text-white px-[44px] flex items-center justify-center rounded-[31px] outline outline-white w-fit text-[24px]  cursor-pointer'>
            <LangText lngKey='ad839901'>{t('ad839901')}</LangText>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HanedaShop